<template>
  <div :class="cssClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      required: false
    }
  },

  computed: {
    cssClass() {
      return {
        'c-alert': true,
        ['c-alert--' + this.variant]: this.variant
      };
    }
  }
};
</script>
